// extracted by mini-css-extract-plugin
export default {"img-top2":"style_img-top2__iBqRB","img-top4":"style_img-top4__6IP6W","cta-btn":"style_cta-btn__SCAer","backYellow":"style_backYellow__WDnZl","can-common":"style_can-common__PjvIM"};